module.exports = __webpack_public_path__ + "img/introduce2.8d6dd20f.png";